export default {"src":"/_next/static/media/blackFreesbeLogo.317e5a05.svg","height":38,"width":129,"blurWidth":0,"blurHeight":0};